module.exports = __webpack_public_path__ + "img/company11.b1dce9af.png";